<form [formGroup]="formCard" class="space-y-5">
  <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200"> Número de dispositivo</label>
      <input pInputText formControlName="cardNumber" class="w-full mt-1" />
    </div>
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Estado del dispositivo</label>
      <div class="flex items-center gap-3 mt-2">
        <p-toggleswitch [(ngModel)]="statusValue" [ngModelOptions]="{standalone: true}" [disabled]="!isAdmin" (onChange)="onStatusChange($event.checked)" />
        <span class="text-sm font-medium" [ngClass]="statusValue ? 'text-green-600' : 'text-red-500'">{{ statusValue ? 'Activo' : 'Inactivo' }}</span>
      </div>
    </div>
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Productos autorizados para carga</label>
      <div class="flex flex-wrap items-center gap-2 mt-2">
        @for(product of cardProducts; track product.value) {
          <p-chip [label]="product.product" [removable]="isAdmin && cardProducts.length > 1" (onRemove)="removeProduct(product)" />
        }
        @if(isAdmin && availableProducts.length > 0) {
          <div class="relative">
            <button pButton type="button" icon="pi pi-plus" class="p-button-sm p-button-rounded p-button-text"
              pTooltip="Agregar producto" (click)="showAddProduct = !showAddProduct"></button>
            @if(showAddProduct) {
              <div class="absolute left-0 top-full mt-1 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg z-10 py-1">
                @for(product of availableProducts; track product.value) {
                  <button type="button" class="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 dark:hover:bg-gray-700 whitespace-nowrap"
                    (click)="addProduct(product); showAddProduct = false">
                    {{ product.product }}
                  </button>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
    @if(device.enableVideoButton === '1') {
      <div>
        <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Guardar video de carga</label>
        <p-select [options]="videoOptions" formControlName="enableVideoLoad" optionLabel="label" optionValue="value" class="w-full mt-1" />
      </div>
    }
    <div>
      <label class="text-xs font-medium text-vivid-royal-600 dark:text-vivid-royal-200">Tipo de Dispositivo</label>
      <input pInputText formControlName="deviceType" class="w-full mt-1" />
    </div>
  </div>

  @if(showMessageError) {
    <div class="text-sm text-red-700 bg-red-100 border border-red-300 rounded-lg px-3 py-2">{{ messagesError }}</div>
  }

  @if(isAdmin) {
    <div class="flex justify-end">
      <button pButton label="Guardar" icon="pi pi-check" class="p-button-sm" type="button" (click)="showConfirmDialog()"></button>
    </div>
  }
</form>

<!-- Confirm dialog -->
<p-dialog header="Confirmar cambios" [(visible)]="showConfirm" [modal]="true" [style]="{width: '400px'}">
  <p class="text-sm whitespace-pre-line">{{ messageConfirm }}</p>
  <ng-template #footer>
    <button pButton label="Cancelar" class="p-button-text" (click)="showConfirm=false"></button>
    <button pButton label="Aceptar" (click)="showConfirm=false; saveCardData()"></button>
  </ng-template>
</p-dialog>
